import { Exclude, Expose, Type } from "class-transformer";
import { IsArray, IsBoolean, IsDefined, IsInt, IsUUID } from "class-validator";

import { VehicleTypePriceFee } from "./VehicleTypePriceFee";

@Exclude()
export class RouteLocation {
    @IsUUID("4")
    @IsDefined()
    @Expose()
    public locationId: string;

    @IsInt()
    @IsDefined()
    @Expose()
    public order: number = 0;

    @IsInt()
    @IsDefined()
    @Expose()
    public defaultDuration: number;

    @IsBoolean()
    @IsDefined()
    @Expose()
    @Type(() => Boolean)
    public isSuggested: boolean = false;

    @IsBoolean()
    @IsDefined()
    @Expose()
    @Type(() => Boolean)
    public isFirst: boolean = false;

    @IsInt()
    @IsDefined()
    @Expose()
    public tollPrice: number = 0;

    @IsInt()
    @IsDefined()
    @Expose()
    public tollFee: number = 0;

    @IsInt()
    @IsDefined()
    @Expose()
    public additionalPrice: number = 0;

    @IsInt()
    @IsDefined()
    @Expose()
    public additionalFee: number = 0;

    @IsArray()
    @IsDefined()
    @Expose()
    @Type(() => VehicleTypePriceFee)
    public vehicleTypesPricesFees: VehicleTypePriceFee[] = [];
}
